import { Injectable, inject } from '@angular/core'
import { Action, Store, select } from '@ngrx/store'

import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'
import * as CategoriesSelectors from './categories.selectors'

@Injectable({
  providedIn: 'root',
})
export class CategoriesFacade implements GbBaseFacade {
  private readonly store = inject(Store)

  loaded$ = this.store.pipe(select(CategoriesSelectors.selectCategoriesLoaded))
  allCategories$ = this.store.pipe(select(CategoriesSelectors.selectAllCategories))
  selectedCategories$ = this.store.pipe(select(CategoriesSelectors.selectEntity))
  count$ = this.store.select(CategoriesSelectors.selectCount)
  searchHistory$ = this.store.select(CategoriesSelectors.selectSearchHistory)
  editCreateLoaded$ = this.store.select(CategoriesSelectors.selectEditCreateLoaded)
  dataView$ = this.store.select(CategoriesSelectors.selectDataView)

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
